<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="供货商名称">
              <a-input v-model.trim="queryParam.name" placeholder=""/>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24" style="float:left">
            <a-form-item label="供应商名称">
              <a-select showSearch v-model="queryParam.supplierId" style="max-width: 320px" :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in supplierSelect" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="!advanced && 4 || 4" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" v-if="queryShow" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            <!--   <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator" v-if='roleId === config.RoleType.ADMIN ||roleId === config.RoleType.PLAN || buttonShow || saveShow'>
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1500 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
    <span slot="serial" slot-scope="text, record, index">
      {{ index + 1 }}
    </span>

      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)" v-if='updateShow'>编辑</a>
      <!--  <a @click="handleEdit(record)" v-if='roleId === config.RoleType.ADMIN || buttonShow'>编辑</a>-->
         <a-divider type="vertical" v-if='deleteShow && updateShow'/>
       <!-- <a-divider type="vertical" v-if='roleId === config.RoleType.ADMIN || buttonShow'/>-->
       <!-- <a-dropdown v-if='roleId === config.RoleType.ADMIN || buttonShow' >-->
          <a-dropdown v-if='deleteShow' >
          <a class="ant-dropdown-link"> 更多<a-icon type="down"/></a>
          <a-menu slot="overlay">
            <a-menu-item v-if="deleteShow"><a @click="handleDel(record)">删除</a></a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>

    <a-modal
      title="操作"
      style="top: 200px;"
      :width="800"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
      :maskClosable="config.globlaMaskClosable"
    >
      <a-form :form="form">
        <a-form-item label="名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="供货商名称" v-decorator="['name', { initialValue: mdl.name, rules: [{ required: true, message: '请输入供货商名称'}]}]"/>
        </a-form-item>

        <a-form-item label="编码" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="供货商编码" v-decorator="['code', { initialValue: mdl.code, rules: [{ required: false, message: '请输入供货商编码'}]}]"/>
        </a-form-item>

        <a-form-item label="供应商" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select showSearch style="max-width: 380px" :filterOption="filterOption" placeholder="请选择" default-value="" v-decorator="['supplierId',
          { initialValue: mdl.supplierId, rules: [{ required: true, message: '请选择供应商'}]}]">
            <a-select-option v-for="(item, index) in supplierSelect" :key="index" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
     
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import { STable } from '@/components'
  import { corpProviderPage, corpProviderDelete, corpProviderSave, getCorpSupplierList, findBySupplierId,userMenuPrivilege} from '@/api/basic'
  import { formatDate } from '@/utils/date'
  import Bus from '@/layouts/bus'
  import config from '@/config/defaultSettings'

  export default {
    name: 'CorpProvider',
    components: {
      STable
    },
    data () {
      return {
        queryShow:false,
        updateShow:false,
        deleteShow:false,
        saveShow:false,
        buttonShow:false,
        buttonShowRoleList:[this.config.RoleType.PURCH],
        pageSizeOptionsList:['10'],
        description: '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this),
        mdl: {},

        supplierSelect: [],

        // 高级搜索 展开/关闭
        advanced: true,
        // 查询参数
        queryParam: {},
        loading:false,
        roleId: null,
        userId: null,
        // 表头
        columns: [
          {
            title: '#',
            scopedSlots: { customRender: 'serial' },
            width: '40px',
            fixed: 'left'
          },
          {
            title: '名称',
            dataIndex: 'name',
            width: '300px',
          },
          {
            title: '编号',
            dataIndex: 'code',
            width: '140px',
          },
          {
            title: '所属供应商',
            dataIndex: 'supplierName',
            //width: '160px',
          },
          {
          title: '创建人',
          dataIndex: 'createId',
          width: '100px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '160px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '100px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '160px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
          {
            title: '操作',
            width: '130px',
            fixed: 'right',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ],
 
        loadSelect() {
          new Promise(resolve => {
              const data = getCorpSupplierList({}).then(res => {
                return res.data
              })
              resolve(data)
            }).then(res => {
              this.supplierSelect = res
          })
        },

        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          if (this.queryParam.createTime !== undefined && this.queryParam.createTime.length > 1) {
            this.queryParam['startTime'] = formatDate(new Date(this.queryParam.createTime[0]), 'yyyy-MM-dd hh:mm:ss')
            this.queryParam['endTime'] = formatDate(new Date(this.queryParam.createTime[1]), 'yyyy-MM-dd hh:mm:ss')
          }
          return corpProviderPage(Object.assign(parameter, this.queryParam))
            .then(res => {
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],

        options: {
          alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        optionAlertShow: true
      }
    },
    created () {
      this.tableOption()
      this.loadSelect()
      this.roleId = this.$store.getters.roles
      this.userId = this.$store.getters.id
      if(this.buttonShowRoleList.includes(this.roleId )){
        this.buttonShow=true
      }else{
        this.buttonShow=false
      }
      this.queryUserMenuPrivilege();
    },
    mounted() {
      // setTimeout(() => {
      //   $('.blacktr').parents('tr').css("border-left", "10px solid #000")
      // }, 1000);
    },
    methods: {
      queryUserMenuPrivilege(){
        userMenuPrivilege(Object.assign({}, {
          userId:this.userId,
          menuId: this.config.corpProviderPrivilegeCode.menuId
        }))
          .then(res => {
            if (res.code === '0') {
              var privilegeString=res.data
              if(privilegeString.indexOf(this.config.corpProviderPrivilegeCode.query)>=0){
                this.queryShow=true
              }
              if(privilegeString.indexOf(this.config.corpProviderPrivilegeCode.update)>=0){
                this.updateShow=true
              }
              if(privilegeString.indexOf(this.config.corpProviderPrivilegeCode.delete)>=0){
                this.deleteShow=true
              }
              if(privilegeString.indexOf(this.config.corpProviderPrivilegeCode.save)>=0) {
                this.saveShow = true
              }
            }
          })
          .catch(() => {
          })
          .finally(() => {
          })

      },
      filterOption (input, option) { // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      tableOption () {
        if (!this.optionAlertShow) {
          this.options = {
            alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
            rowSelection: {
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange
            }
          }
          this.optionAlertShow = true
        } else {
          this.options = {
            alert: false,
            rowSelection: null
          }
          this.optionAlertShow = false
        }
      },

      handleEdit (record) {
        this.mdl = Object.assign({}, record)
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.visible = true
      },

      handleAdd () {
        this.mdl = {}
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.visible = true
      },
      handleOk () {
        this.form.validateFields((err, values) => {
          Object.assign(this.mdl, values)
          if (!err) {
            this.confirmLoading = true
            corpProviderSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
            })
            
          }
        })
      },
    
      handleDel (record) {
        var nthis = this
        this.$confirm({
          title: '提示',
          content: '确定要删除吗?',
          onOk () {
            nthis.confirmLoading = true
            return corpProviderDelete(Object.assign(record, nthis.queryParam))
              .then(res => {
                if (res.code === '0') {
                  nthis.$refs.table.refresh()
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                nthis.confirmLoading = false
              })
          },
          onCancel () {
          }
        })
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
    
      beforeUpload (file) {

      },
      downLoad(){
        let url=this.config.downLoadMouldUrl+"供应商.xlsx"
        window.location.href=url
      },
    
    },
    watch: {

    },

  }

</script>
